import { STORE_KEY } from '@/helpers/firstDataFetcher';
import * as Sentry from '@sentry/vue';

export function setVitalsLogger() {
  let lcp = 10000;

  function sendToSentry(event) {
    Sentry.captureEvent({
      message: 'Layout shift',
      level: 'info',
      extra: event,
    });
  }

  // eslint-disable-next-line no-unused-vars
  const handleLayoutShifts = entries => {
    entries.forEach(entry => {
      if (entry.value > 0.05) {
        const details = entry.sources.map(
          s =>
            `"${s.node?.offsetParent?.className || s.node?.offsetParent?.tagName}">"${
              s.node?.className || s.node?.tagName
            }"`
        );

        const event = {
          value: +entry.value.toFixed(4),
          store: sessionStorage.getItem(STORE_KEY),
          view: window.location.pathname.replace('/dashboard', ''),
          nodes: details,
        };

        sendToSentry(event);
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.debug('CLS', {
            value: event.value,
            view: event.view,
            nodes: entry.sources.map(e => e.node),
          });
        }
      }
      // }
    });
  };

  const clsObserver = new PerformanceObserver(list => {
    handleLayoutShifts(list.getEntries());
  });
  const responseTimeObserver = new PerformanceObserver(list => {
    const entries = list.getEntries();

    entries
      .filter(entry => entry.fetchStart < lcp + 3000)
      .forEach(entry => {
        const { pathname, host } = new URL(entry.name);

        if (entry.duration > 300) {
          const speed =
            entry.duration < 600 ? 'moderate' : entry.duration > 1500 ? 'super slow' : 'slow';

          const endpoint = pathname.replace(/\/\d+\//g, '/<int:id>/');

          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.debug('REQUEST_RESP:', host, endpoint, parseInt(entry.duration) + 'ms');
          } else {
            Sentry.captureEvent({
              message: 'Slow Response',
              level: 'info',
              extra: {
                ...entry,
                lcp: parseInt(lcp),
                duration: parseInt(entry.duration),
                pathname,
              },
              tags: {
                speed,
                host,
                endpoint,
                pathname,
                isBlocking: entry.renderBlockingStatus,
              },
            });
          }
        }
      });
  });
  const lcpObserver = new PerformanceObserver(list => {
    const entries = list.getEntries();
    const lastEntry = entries[entries.length - 1]; // Use the latest LCP candidate

    lcp = lastEntry.startTime;

    if (lastEntry.startTime > 2500) {
      Sentry.captureEvent({
        message: 'Large LCP',
        level: 'info',
        extra: lastEntry,
      });

      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.debug('LCP', lastEntry);
      }
    }
  });
  lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
  clsObserver.observe({ type: 'layout-shift', buffered: true });
  responseTimeObserver.observe({ type: 'resource', buffered: true });
}
